import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

import Ea from '@/views/ea/Start.vue';
import Ae from './views/ae/Start.vue';
import AeSet from './views/ae/Set.vue';
import AnimationStandalone from './views/ae/AnimationStandalone.vue';
import Ce from './views/ce/Start.vue';
import CeIntrouduction from './views/ce/Introduction.vue';
import CeMatrix from './views/ce/Matrix.vue';
import CeSubset from './views/ce/Subset.vue';
import Search from './views/Search.vue';
import About from './views/About.vue';
import Impressum from './views/Impressum.vue';
import Datenschutz from './views/Datenschutz.vue';
import Help from './views/Help.vue';
import Timeline from './views/Timeline.vue'

Vue.use(Router);

export default new Router({
  // base: '/eLaterna/',
  routes: [{
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/ea',
      name: 'eLaterna_archive',
      component: Ea
    },
    {
      path: '/ae',
      name: 'archive_edition',
      component: Ae
    },
    {
      path: '/ae/:ssid',
      name: 'archive_edition_set',
      component: AeSet
    },
    {
      path: '/ae/animation/:ssid/:sid/:order',
      name: 'animation_standalone',
      component: AnimationStandalone
    },
    {
      path: '/ce',
      name: 'critical_edition',
      component: Ce
    },
    {
      path: '/ce/:ceid',
      name: 'creitical_edition_introduction',
      component: CeIntrouduction
    },
    {
      path: '/ce/:ceid/matrix',
      name: 'creitical_edition_matri',
      component: CeMatrix
    },
    {
      path: '/ce/:ceid/subset/:cpid',
      name: 'creitical_edition_subset',
      component: CeSubset
    },
    {
      path: '/search',
      name: 'search',
      component: Search
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/impressum',
      name: 'impressum',
      component: Impressum
    },
    {
      path: '/datenschutz',
      name: 'datenschutz',
      component: Datenschutz
    },
    {
      path: '/help',
      name: 'help',
      component: Help
    },
    {
			path: '/timeline',
			name: 'timeline',
			component: Timeline
		}
  ]
});

